// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2nqQf","content":"styles_content__1ZXxM","selectAll":"styles_selectAll__2AbH7"};